import { createAction, props } from "@ngrx/store";
import { Notification, NotificationInfo } from "@uzurv/clara";
import { HttpException } from "@uzurv/core";
import { AuthenticatedUser } from "@uzurv/http";

export const loginSuccess = createAction('[User] Login success', props<{ user: AuthenticatedUser }>());

export const listNotifications = createAction('[User] List notifications');
export const listNotificationsSuccess = createAction('[User] List notifications success', props<{notifications: Array<NotificationInfo> }>());
export const listNotificationsFail = createAction('[User] List notifications fail', props<{ error: HttpException }>());

export const deleteNotification = createAction('[User] Delete notification', props<{ notificationId: number }>());
export const deleteNotificationSuccess = createAction('[User] Delete notification success');
export const deleteNotificationFail = createAction('[User] Delete notification fail', props<{ error : HttpException }>());
